import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/rootReducer';

// Thunk extras for RRF v3 / redux-firestore
import { getFirebase } from 'react-redux-firebase';
import { getFirestore } from 'redux-firestore';

export const configureStore = (preloadedState) => {
  const middlewares = [thunk.withExtraArgument({ getFirebase, getFirestore })];
  const middlewareEnhancer = applyMiddleware(...middlewares);

  const composedEnhancer = composeWithDevTools(middlewareEnhancer);

  const store = createStore(rootReducer, preloadedState, composedEnhancer);

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('../reducers/rootReducer', () => {
      const newRootReducer = require('../reducers/rootReducer').default;
      store.replaceReducer(newRootReducer);
    });
  }

  return store;
};
